module.exports = __webpack_public_path__ + "img/90-ring-with-bg.de3ff795.svg";